import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d1b1a02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "hist" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list fa-fw" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_saved_est_tbl = _resolveComponent("saved-est-tbl")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _createTextVNode(" 保存見積")
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            (_ctx.message.err)
              ? (_openBlock(), _createBlock(_component_el_alert, {
                  key: 0,
                  title: _ctx.message.msg,
                  type: "error"
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(_component_saved_est_tbl, {
              orderlist: _ctx.orderList,
              loading: _ctx.loading,
              onDel: _ctx.del
            }, null, 8, ["orderlist", "loading", "onDel"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_alert, {
              title: "部数、金額は保存時のものです。",
              type: "info",
              closable: false,
              "show-icon": ""
            }),
            _createVNode(_component_el_alert, {
              title: "金額は税別表示です。",
              type: "info",
              closable: false,
              "show-icon": ""
            }),
            _createVNode(_component_router_link, { to: "/mypage" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode("戻る")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}